import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white border-t-2 border-black"
    >
      <div className="px-6 md:px-12 lg:px-20 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 flex flex-col items-center md:items-start text-center md:text-left">
          <img
            src="/assets/logo-white.png"
            alt="Infinagon"
            className="h-32 md:h-40 w-auto object-contain mb-4"
          />
          <p className="font-script text-2xl text-white/85 mt-0">
            · Est. 2021 ·
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/60 mb-4">
            Navigate
          </p>
          <ul className="space-y-3">
            <li><Link to="/" className="font-script text-3xl hover:text-white/60">Home</Link></li>
            <li><a href="/#services" className="font-script text-3xl hover:text-white/60">Services</a></li>
            <li><a href="/#ab-player" className="font-script text-3xl hover:text-white/60">Listen</a></li>
            <li><a href="/#studio" className="font-script text-3xl hover:text-white/60">Gear</a></li>
            <li><Link to="/shop" className="font-script text-3xl hover:text-white/60">Shop</Link></li>
            <li><a href="/#contact" className="font-script text-3xl hover:text-white/60">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/60 mb-4">
            Studio
          </p>
          <address className="not-italic space-y-2 text-white/85 font-script text-2xl leading-snug">
            <div>4030 Wake Forest Road, Ste 349</div>
            <div>Raleigh, NC 27609</div>
            <div className="pt-3">
              <a href="mailto:rasheed@infinagonrecordings.com" className="hover:text-white/60">
                rasheed@infinagonrecordings.com
              </a>
            </div>
            <div>
              <a href="tel:+19198096053" className="hover:text-white/60">
                (919) 809-6053
              </a>
            </div>
            <div className="pt-3 font-mono text-[11px] tracking-[0.25em] uppercase text-white/60">
              Mon–Sat · 08:00 – 17:00
            </div>
          </address>
        </div>
      </div>
      <div className="border-t border-white/15 px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row justify-between gap-4 font-mono text-[11px] tracking-[0.2em] uppercase text-white/55">
        <span>© {new Date().getFullYear()} Infinagon Recordings LLC</span>
        <span>All Rights Reserved</span>
      </div>
    </footer>
  );
};

export default Footer;
